import axios from 'axios';

import { ApiConfig } from '../types';
import { toSerializedError } from '../errors/utils';

export type AuthorizationCodeBody = {
  grant_type: 'authorization_code';
  code: string;
  redirect_uri: string;
  client_id: string;
};

export type PasswordLoginBody = {
  grant_type: 'password';
  username: string;
  password: string;
  client_id: string;
  scope?: string;
};

export type RefreshTokenBody = {
  grant_type: 'refresh_token';
  refresh_token: string;
  client_id: string;
};

export type LoginResponse = {
  access_token: string;
  token_type: 'Bearer';
  refresh_token?: string;
  expires_in: number;
  scope: string;
};

export async function createToken({ api_url }: { api_url: string }, body: PasswordLoginBody|RefreshTokenBody|AuthorizationCodeBody) {
  try {
    let res = await axios.post<LoginResponse>(api_url+'/api/oauth/token', body);
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type SendOTPBody = {
  type: 'email_signup' | 'email_login' | 'email_forgot_password';
  client_id: string;
  email: string;
};
export type SendOTPResponse = {
  request_id: string;
};
export async function sendOTP({ api_url }: { api_url: string; }, body: SendOTPBody) {
  try {
    let res = await axios.post<SendOTPResponse>(api_url+'/api/oauth/otp', body);
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type ResetPasswordBody = {
  password: string;
};
export type ResetPasswordResponse = {
  request_id: string;
};
export async function resetPassword({ api_url, headers }: ApiConfig, body: ResetPasswordBody) {
  try {
    let res = await axios.put<ResetPasswordResponse>(api_url+'/api/users/me/password', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type GetTokenInfoResponse = {
  tenant_id: string;
  scope: string;
};

export async function getTokenInfo({ api_url, headers }: ApiConfig) {
  try {
    let res = await axios.get<GetTokenInfoResponse>(api_url+'/api/oauth/token', {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type GetProfileResponse = {
  id: string;
  username: string;
  allowed_grant_type: 'password'|'refresh_token';
};

export async function getProfile({ api_url, headers }: ApiConfig) {
  try {
    let res = await axios.get<GetProfileResponse>(api_url+'/api/users/me', {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}
